export default __webpack_public_path__ + "static/NNNittiGrotesk-Heading-f7773eec358752c524adee73401d4648.woff";